<section class="ikon-pass-section">
  <div class="ikon-pass-header">
    Ikon Pass Discount <img class="ikon-pass-logo" src="assets/icon/ikon-pass.svg">
  </div>
  <div class="ikon-pass-desc"
       (mouseenter)="showTooltip = true"
       (mouseleave)="showTooltip = false"
       (click)="showTooltip = !showTooltip">
    Click to hover to see how to find your Ikon Pass number that starts with an i <mat-icon class="help-icon">help</mat-icon>
    <div class="custom-tooltip" *ngIf="showTooltip">
      <img src="assets/images/ikon-pass-info.png" alt="Ikon Pass Example" />
    </div>
  </div>
  <div class="field">
    <div class="ikon-wrap">
      <input name="ikon-number"
             [(ngModel)]="ikonPassNumber"
             type="text"
             placeholder="Enter your Ikon pass number"
             class="ikon-number" />
      <button class="ikon-apply"
              [class.action-disabled]="!ikonPassNumber || inProgressDelete || inProgress"
              [disabled]="!ikonPassNumber || inProgressDelete || inProgress"
              (click)="saveIkon()">
        {{inProgress ? '' : 'Save'}} <mat-spinner diameter="40" *ngIf="inProgress"></mat-spinner>
      </button>
      <button class="ikon-apply delete"
              [class.action-disabled]="!ikonPassNumber || inProgress"
              [hidden]="!ikonPassNumber"
              [disabled]="inProgressDelete || inProgress"
              (click)="deleteIkonPass()">
        {{inProgressDelete ? '' : 'Delete'}} <mat-spinner diameter="40" *ngIf="inProgressDelete"></mat-spinner>
      </button>
    </div>
    <p class="ikon-error" *ngIf="invalidIkon">
      Invalid Ikon Pass number
    </p>
  </div>
</section>

